import { render, staticRenderFns } from "./DarkBar.vue?vue&type=template&id=664414c8&scoped=true&"
import script from "./DarkBar.vue?vue&type=script&lang=ts&"
export * from "./DarkBar.vue?vue&type=script&lang=ts&"
import style0 from "./DarkBar.vue?vue&type=style&index=0&id=664414c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664414c8",
  null
  
)

export default component.exports